// Translations
import form from '../sections/form/translations/ar'

// Translation: Login > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
